import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import {MailService} from "../../service/mail.service";
import {MailRequest} from "../../model/mail-request";
import {NotificationService} from "../../service/notification.service";
import {User} from "../../model/user";
import {PlatformUtils} from "../../utils/platform-utils";

/**
 * contact form inside a modal
 */
@Component({
  selector: 'app-contact-overlay',
  templateUrl: './contact-overlay.component.html',
  styleUrls: ['./contact-overlay.component.css']
})
export class ContactOverlayComponent implements OnInit {

  @Input() displayed: boolean = false;
  @Input() toNextPage: boolean;
  // allows to call functions or change variables etc. from another component, this component is part of
  @Output() modalClosed = new EventEmitter();
  contactForm: UntypedFormGroup;
  errorMsg: string;

  @Input() user: User;
  @Input() requestDocumentPriceName: string;
  @Input() isRegisterComponent: boolean = false;

  constructor(private formBuilder: UntypedFormBuilder, private mailService: MailService, private notificationService: NotificationService) {
  }

  ngOnInit(): void {
    const currentMultiUserPlatform = PlatformUtils.getCurrentMultiUserPlatformProfileFromSession();

    this.contactForm = this.formBuilder.group({
      firstName: new UntypedFormControl(""),
      name: new UntypedFormControl(""),
      company: new UntypedFormControl(""),
      mail: new UntypedFormControl("", Validators.required),
      phone: new UntypedFormControl(""),
      text: new UntypedFormControl("", Validators.required)
    });

    if (this.user) {
      this.contactForm.patchValue({
        firstName: this.user.firstname,
        name: this.user.lastname,
        company: currentMultiUserPlatform?.company ?? "-",
        mail: this.user.mail,
        text: this.getDocumentPricingRequestText()
      })
    }

    if(this.isRegisterComponent){
      this.contactForm.patchValue({
        text: this.getAccountRequestText()
      })

      Object.keys(this.contactForm.controls).forEach(key => {
        if(key !== "phone"){
          this.contactForm.controls[key].setValidators(Validators.required)
          this.contactForm.controls[key].updateValueAndValidity();
        }
      })

    }
  }

  getDocumentPricingRequestText(): string {
    return "Sehr geehrte Damen und Herren,\n\nhiermit beantrage ich einen Preis für das Dokument: "
      + this.requestDocumentPriceName + ".\n\nMit freundlichen Grüßen\n" + this.user.firstname + " " + this.user.lastname
  }

  getAccountRequestText() : string{
    return "Sehr geehrte Damen und Herren,\n\nhiermit beantrage ich einen Account, um die Connect+ Plattform nutzen zu können.\n\nMit freundlichen Grüßen"
  }

  requestMail(): void {
    if (!this.contactForm.valid) {
      this.errorMsg = "Bitte geben Sie alle relevanten Daten an.";
      this.markInvalidInputs();
    } else {
      this.errorMsg = null;
      let mailRequest: MailRequest = this.contactForm.value;
      this.mailService.sendMail(mailRequest).subscribe(() => {
          this.notificationService.success("Danke! Wir haben Ihre Anfrage erhalten.");
          this.displayed = false;
        });
    }
  }

  hasRequiredValidator(control: AbstractControl): boolean {
    return control.hasValidator(Validators.required)
  }

  hasError(control: AbstractControl): boolean {
    return (control.invalid && (control.touched || this.toNextPage));
  }

  closeContactForm() {
    this.modalClosed.emit();
  }

  markInvalidInputs(){
    Object.keys(this.contactForm.controls).forEach(key => {
      if(this.contactForm.get(key) instanceof UntypedFormControl){
        this.contactForm.get(key).markAsTouched()
      }
    })
  }

}
